export default {
  fonts: {
    logo: 'Bowlby One SC, cursive',
    body: 'Inconsolata, monospace',
    heading: 'Acme, sans-serif',
  },
  fontSizes: [16, 24, 32, 40, 56, 72],
  letterSpacing: [0, 1, 2, 3],
  space: [0, 5, 10, 15, 20, 30, 40, 50, 75, 100, 200],
  colors: {
    text: '#000',
    background: '#eee',
    backgroundSecondary: '#fff',
    primary: 'hotpink',
    secondary: 'lime',
    correct: '#0f0',
    error: '#f00',
  },
  breakpoints: ['500px'],
  styles: {
    h2: {
      fontSize: 2,
      fontFamily: 'heading',
      textTransform: 'uppercase',
      marginTop: 0,
      marginBottom: 3
    }
  }

}